import React from "react";
import { browserHistory } from "react-router";
import AlertMessageClass from "../../shared/components/alert_message";

import LaddaButton, { EXPAND_RIGHT, S } from "react-ladda";
import { Card, CardBlock, FormGroup, Input, Label } from "reactstrap";
import appicon from "../../assets/images/asepsis-logo.svg";
import { postRequest } from "../../utils/apiUtils";
import { CLIENT_ID, TOKEN, USER_ID } from "../../utils/constants/localstoregeConstants";
import "./style.css";
var axios = require("axios");
var simpleReactValidator = require("simple-react-validator");

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new simpleReactValidator();
    this.state = {
      data: [],
      loading: false,
      passwordValue: "",
      emailValue: "",
      alertMessageText: "",
      alertMessageVisible: false,
      alertMessageColor: "",
    };
    this.emailChange = this.emailChange.bind(this);

    this.passChange = this.passChange.bind(this);

    this.onDismiss = this.onDismiss.bind(this);
  }

  emailChange = (e) => {
    this.setState({
      emailValue: e.target.value,
    });
  };

  passChange = (e) => {
    this.setState({
      passwordValue: e.target.value,
    });
  };
  onDismiss() {
    var that = this;
    that.setState({
      alertMessageVisible: false,
    });
  }

  btnLogin = () => {
    var that = this;
    if (that.validator.allValid()) {
    } else {
      that.validator.showMessages();
      // rerender to show messages for the first time
      that.forceUpdate();
    }
    var email = that.state.emailValue;
    //console.log(email);
    var password = that.state.passwordValue;
    //console.log(password);
    if (email !== "" && password !== "") {
      that.setState({
        loading: !this.state.loading,
        progress: 0.1,
      });
      postRequest({
        url: "api/admin_login",
        payload: {
          email: email,
          password: password,
        },
      })
        .then(function (response) {
          console.log("response :>> ", response);
          if (response.data.success) {
            localStorage.setItem(USER_ID, response.data.result.luser_id);
            localStorage.setItem(TOKEN, response.data.result.token_id);
            localStorage.setItem(CLIENT_ID, response.data.result.client_id);

            browserHistory.push("/questions");
            window.location.reload();
            // return (<Redirect to="/dashboard" />);
          } else {
            if (response.data.success) {
              that.setState({
                alertMessageVisible: true,
                alertMessageColor: "danger",
                alertMessageText: response.data.message,
                loading: false,
              });
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 403) {
            } else {
              console.log(error);
            }
          } else {
            console.log(error);
          }
        });
    }
  };
  render() {
    const AlertMessage = () => (
      <AlertMessageClass
        alertMessageText={this.state.alertMessageText}
        alertMessageVisible={this.state.alertMessageVisible}
        alertMessageColor={this.state.alertMessageColor}
        onDismiss={this.onDismiss}
      />
    );
    return (
      <div className="view">
        <div className="view-content view-pages view-session d-flex justify-content-center align-items-center flex-column">
          <Card className="mb-3 form-card">
            <CardBlock>
              <header className="mb-5">
                <div className="d-flex justify-content-center">
                  <img src={appicon} width="150" alt="logo" />
                </div>
              </header>

              <AlertMessage />
              <FormGroup className="mb-4">
                <Label>User Name</Label>
                <Input type="email" placeholder="email" value={this.state.emailValue} onChange={this.emailChange} maxLength="50" />
                <span className="error-text">{this.validator.message("email", this.state.emailValue, "required")}</span>
              </FormGroup>
              <FormGroup className="mb-4">
                <Label>Password</Label>
                <Input type="password" placeholder="password" value={this.state.passwordValue} onChange={this.passChange} maxLength="50" />
                <span className="error-text">{this.validator.message("password", this.state.passwordValue, "required")}</span>
              </FormGroup>
              <FormGroup className="text-right">
                {/* <Button color="primary">Sign In</Button> */}
                <LaddaButton
                  className="btn btn-primary"
                  loading={this.state.loading}
                  onClick={this.btnLogin}
                  data-color="#eee"
                  data-size={S}
                  data-style={EXPAND_RIGHT}
                  data-spinner-size={30}
                  data-spinner-color="#ddd"
                  data-spinner-lines={12}
                >
                  Sign In
                </LaddaButton>
              </FormGroup>
            </CardBlock>
          </Card>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/login/index.js